import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiForgotPassword } from './authApi';
import AuthCard from './AuthCard';
import '../styles/Auth.css';

// Page /mot-de-passe-oublie : envoie un lien de réinitialisation (valable 1 h) si l'adresse a un
// compte. La réponse est la même dans tous les cas, pour ne pas révéler quelles adresses en ont un.
export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await apiForgotPassword(email);
            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (sent) {
        return (
            <AuthCard
                title="Vérifiez votre messagerie"
                subtitle={`Si un compte Walter existe pour ${email}, un email vient de partir avec un lien pour choisir un nouveau mot de passe. Il est valable 1 heure.`}
            >
                <p className="auth-hint">
                    Rien reçu après quelques minutes ? Regardez dans les indésirables, ou demandez un lien à un administrateur Hydros.
                </p>
                <Link className="auth-link" to="/login">Retour à la connexion</Link>
            </AuthCard>
        );
    }

    return (
        <AuthCard title="Mot de passe oublié" subtitle="Indiquez l'email de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe.">
            <form className="auth-form" onSubmit={handleSubmit}>
                <div className="auth-field">
                    <label htmlFor="forgot-email">Email</label>
                    <input
                        id="forgot-email" type="email" autoComplete="username" required autoFocus
                        value={email} onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                {error && <div className="auth-error" role="alert">{error}</div>}
                <button type="submit" className="auth-btn auth-btn--primary" disabled={submitting}>
                    {submitting ? 'Envoi…' : 'Recevoir un lien'}
                </button>
                <Link className="auth-link" to="/login">Retour à la connexion</Link>
            </form>
        </AuthCard>
    );
}
